import React from 'react';
import { Element } from '../../types';
import './GameField.css'; // Используем существующие стили

interface NewElementAnimationProps {
  element: Element;
  position: {
    x: number;
    y: number;
  };
}

/**
 * Компонент для отображения анимации создания нового элемента
 */
const NewElementAnimation: React.FC<NewElementAnimationProps> = ({ element, position }) => {
  return (
    <div 
      className="new-element-animation"
      style={{
        left: position.x,
        top: position.y
      }}
    >
      <div className="animation-emoji">{element.emoji}</div>
      <div className="animation-name">{element.name}</div>
      <div className="animation-sparkles">✨</div>
    </div>
  );
};

export default NewElementAnimation; 